import React from 'react';
import { injectIntl } from 'react-intl';

import GameContainer from './GameContainer.js';

import PuzzleCanvas from '../games/PuzzleCanvas_new.js';
import { useCanvasMachine } from '../../ts/games/canvasStateMachine.ts';
import { getSoundPropsById, isNotEmpty } from '../../lib/ep.js';
import ActionLink from '../builder/ActionLink.js';
import MisconfiguredGameWarning from './MisconfiguredGameWarning.js';
import { clientFinalPage } from '../games/StageFinalMessages.js';

const Instructions = (props) => {
	return null;
};

const Legend = (props) => {
	return (
		<aside class="gui_not_in_top_small">
			<ActionLink
				onClick={() => props.gameCanvas.current.showHelp()}
			>Help</ActionLink>
		</aside>
	)
};

const PuzzleClient = ({ stage, ...props }) => {
	const canvas_images = () => {
		const images = [];

		if(isNotEmpty(stage.Stage, 'puzzle_image')) {
			images.push({
				id:'puzzle_image',
				name:stage.Stage.puzzle_image,
				url:stage.Stage.full_puzzle_image,
				fit:'contain'
			})
		}
		
		return images;
	};

	const sound_fx = {
		move_in:new Howl({ ...getSoundPropsById('move_in') }),
		move_out:new Howl({ ...getSoundPropsById('move_out') }),
		success:new Howl({ ...getSoundPropsById('applause') }),
		fail:new Howl({ ...getSoundPropsById('fail') }),
	};

	const [ state, dispatch ] = useCanvasMachine({
		images:canvas_images,
		images_dependencies:[stage.Stage.puzzle_image],
	});

	const display_help = stage.Stage?.display_legend ?? true;

	const final_stage = clientFinalPage(stage, props.actual_state);

	return (
		<GameContainer
			{...props}
			stage={final_stage}
			instructions={<Instructions
				stage={stage}
				intl={props.intl}
			/>}
			legend={(display_help) ? <Legend
				stage={stage}
				is_builder={props.is_builder}
				intl={props.intl}
			/> : null}
			game_type="puzzle"
			display_score={false}
			display_audio_controls={true}
			auto_start_timer={false}
			instructions_has_border={false}
			instructions_classes='gui_flex_align_center'
			sound_fx={sound_fx}
		>
			{(stage.Stage?.puzzle_image ?? false) ? (
				<PuzzleCanvas
					indexed_images={state.images}
				/>
			) : (
				<MisconfiguredGameWarning
					message="Upload an image to create the game"
					img_recommendations={{
						w:800,
						h:800,
					}}
				/>
			)}
		</GameContainer>
	)
};

export default injectIntl(PuzzleClient);